'use strict'

/**
 * @classname ChangePublicationAge
 * @classdesc 「所属」を変更したときスカウトの年齢選択を表示する
 */
export default class ChangePublicationAge {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.show_scout_age')
	 */
	constructor($e, controller) {
		console.log('ChangePublicationAge.constructor')
		this._$e = $e
		this._controller = controller
		this._$ageWrap = $('.age-wrap')
		this._$e.on('change', () => this.onChange())
		this.onChange(0)
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangePublicationAge
	 * @return {undefined}
	 */
	onChange(duration = 300) {
		console.log('ChangePublicationAge.onChange')
		if (this._$e.find('option:selected').data('show-age')) {
			this._$ageWrap
				.slideDown(duration)
				.find('.validate')
				.removeClass('ignore-validate')
		} else {
			this._$ageWrap
				.slideUp(duration)
				.find('.validate')
				.removeClass('is-invalid')
				.addClass('ignore-validate')
				.closest('.form-group')
				.find('.error-tip')
				.removeClass('show')
				.find('.error-tip-inner')
				.html('')
		}
	}
}
